import _get from 'lodash.get';
import { Reducer } from 'redux';
import { PatientsState, PatientsActionTypes } from './type';

export const initialState: PatientsState = {
  // patientMedicalHistory 过往病史  patientAllergicHistory 过敏史  patientFamilyHistory 家族病史  patientHabit 个人习惯
  patientsList: [],
  editPatient: {
    patientHealth: {
      patientMedicalHistory: '[]',
      patientAllergicHistory: '[]',
      patientFamilyHistory: '[]',
      patientHabit: '[]',
    },
    bloodSugarList: [{
      bloodSugar: '',
      highBloodPressure: '',
      lowBloodPressure: '',
      heartRate: '',
    }],
    attachmentList: [],
  },
  patientInquiry: [],
  addFamily: {},
  selfPatientInfo: {},
  defaultPatientRelation:1,
};

const reducer: Reducer<PatientsState> = (state = initialState, action) => {
  switch (action.type) {
  case PatientsActionTypes.EDIT_PATIENT_INFO: {
    const { key, value } = action;
    console.log('key, value', key, value);
    return {
      ...state,
      editPatient: {
        ...state.editPatient,
        [`${key}`]: value,

      },
    };
  }
  case PatientsActionTypes.EDIT_PATIENT: {
    const { data } = action;
    return {
      ...state,
      editPatient: {
        patientHealth: {
          patientMedicalHistory: '[]',
          patientAllergicHistory: '[]',
          patientFamilyHistory: '[]',
          patientHabit: '[]',
        },
        bloodSugarList: [{
          bloodSugar: '',
          highBloodPressure: '',
          lowBloodPressure: '',
          heartRate: '',
        }],
        attachmentList: [],
        ...data,
      },
    };
  }
  case PatientsActionTypes.EDIT_PATIENT_HEALTH: {
    const { key, value } = action;
    return {
      ...state,
      editPatient: {
        ...state.editPatient,
        patientHealth: {
          ...state.editPatient.patientHealth,
          [`${key}`]: JSON.stringify(value),
        },
      },
    };
  }
  case PatientsActionTypes.EDIT_PATIENT_BLOODSUGAR: {
    const { key, value } = action;

    const bloodSugarInfo = _get(state, 'editPatient.bloodSugarList[0]', {});

    bloodSugarInfo[key] = value;

    return {
      ...state,
      editPatient: {
        ...state.editPatient,
        bloodSugarList: [bloodSugarInfo],
      },
    };
  }
  case PatientsActionTypes.FETCH_PATIENT_INQUIRY_SUCCESS: {
    const { data } = action;
    return {
      ...state,
      patientInquiry: data,
    };
  }
  case PatientsActionTypes.FETCH_PATIENT_LIST_SUCCESS: {
    const { data } = action;
    const selfPatient = data.find((item)=>item.patientRelation === 1);
    return {
      ...state,
      patientsList: data,
      selfPatientInfo: selfPatient || {},
    };
  }
  case PatientsActionTypes.SAVE_PATIENT_SUCCESS: {
    return {
      ...state,
      patientsList: [],
      editPatient: {
        patientHealth: {
          patientMedicalHistory: '[]',
          patientAllergicHistory: '[]',
          patientFamilyHistory: '[]',
          patientHabit: '[]',
        },
        bloodSugarList: [{
          bloodSugar: '',
          highBloodPressure: '',
          lowBloodPressure: '',
          heartRate: '',
        }],
        attachmentList: [],
      },
    };
  }
  case PatientsActionTypes.CLEAR_PATIENT: {
    return {
      ...state,
      editPatient: {
        patientHealth: {
          patientMedicalHistory: '[]',
          patientAllergicHistory: '[]',
          patientFamilyHistory: '[]',
          patientHabit: '[]',
        },
        bloodSugarList: [{
          bloodSugar: '',
          highBloodPressure: '',
          lowBloodPressure: '',
          heartRate: '',
        }],
        attachmentList: [],
      },
    };
  }
  case PatientsActionTypes.CLEAR_PATIENT_LIST: {
    return {
      ...state,
      patientsList: [],
    };
  }
  case PatientsActionTypes.CLEAR_PATIENT_INQUIRY: {
    return {
      ...state,
      patientInquiry: [],
    };
  }
  case PatientsActionTypes.FETCH_PATIENT_NO_SUCCESS: {
    const { data } = action;
    return {
      ...state,
      editPatient: {
        ...state.editPatient,
        patientNo: data,
      },
    };
  }
  case PatientsActionTypes.FETCH_PATIENT_DETAIL_SUCCESS: {
    const { data } = action;
    return {
      ...state,
      editPatient: data,
    };
  }
  case PatientsActionTypes.UPLOAD_FILE_SUCCESS: {
    const { data } = action;
    return {
      ...state,
      editPatient: {
        ...state.editPatient,
        attachmentList: [
          ...state.editPatient.attachmentList,
          data,
        ],
      },
    };
  }
  case PatientsActionTypes.DELETE_FILE: {
    return {
      ...state,
      editPatient: {
        ...state.editPatient,
        attachmentList: [
          ...state.editPatient.attachmentList.filter((i) => i.id !== action.id),
        ],
      },
    };
  }
  case PatientsActionTypes.ADD_FAMILY: {
    return {
      ...state,
      addFamily: action.data,
    };
  }
  case PatientsActionTypes.SAVE_DEFAULT_PATIENTRELATION: {
    const { data } = action;
    return {
      ...state,
      defaultPatientRelation: data,
    };
  }
  default: {
    return state;
  }
  }
};

export { reducer as PatientsReducer };
